export interface FeatureFlagsConfig {
  [featureFlagName: string]: {
    enabledGlobally: boolean;
    markets?: {
      [market: string]: boolean;
    };
  };
}

export function isFeatureFlagEnabled(
  featureFlagName: string,
  market: string,
  featureFlagsConfig?: FeatureFlagsConfig,
): boolean {
  if (!featureFlagsConfig) {
    return false;
  }

  const featureFlag = featureFlagsConfig[featureFlagName];

  if (!featureFlag) {
    return false;
  }

  if (featureFlag.enabledGlobally) {
    return true;
  }

  const isEnabledForMarket = featureFlag.markets?.[market.toUpperCase()];

  if (isEnabledForMarket) {
    return true;
  }

  return false;
}
